/** Shared industry and risk category options for supplier create/edit forms. */

export const SUPPLIER_INDUSTRIES = [
  { value: 'Technology', labelKey: 'industryTechnology' },
  { value: 'Healthcare', labelKey: 'industryHealthcare' },
  { value: 'Finance', labelKey: 'industryFinance' },
  { value: 'Manufacturing', labelKey: 'industryManufacturing' },
  { value: 'Retail', labelKey: 'industryRetail' },
  { value: 'Energy', labelKey: 'industryEnergy' },
  { value: 'Transportation', labelKey: 'industryTransportation' },
  { value: 'Automotive', labelKey: 'industryAutomotive' },
  { value: 'Pharmaceuticals', labelKey: 'industryPharmaceuticals' },
  { value: 'Telecommunications', labelKey: 'industryTelecommunications' },
  { value: 'Aerospace', labelKey: 'industryAerospace' },
  { value: 'Consumer Goods', labelKey: 'industryConsumerGoods' },
  { value: 'Food & Beverage', labelKey: 'industryFoodBeverage' },
  { value: 'Other', labelKey: 'industryOther' },
];

export const SUPPLIER_RISK_CATEGORIES = [
  { value: 'Geopolitical Risk', labelKey: 'riskCategoryGeopolitical' },
  { value: 'Supply Chain Disruption', labelKey: 'riskCategorySupplyChainDisruption' },
  { value: 'Technology Risk', labelKey: 'riskCategoryTechnology' },
  { value: 'Cybersecurity Risk', labelKey: 'riskCategoryCybersecurity' },
  { value: 'Market Competition Risk', labelKey: 'riskCategoryMarketCompetition' },
  { value: 'Regulatory Risk', labelKey: 'riskCategoryRegulatory' },
  { value: 'Financial Risk', labelKey: 'riskCategoryFinancial' },
  { value: 'Operational Risk', labelKey: 'riskCategoryOperational' },
  { value: 'Environmental Risk', labelKey: 'riskCategoryEnvironmental' },
  { value: 'Reputational Risk', labelKey: 'riskCategoryReputational' },
];

export const SUPPLIER_TIERS = ['1', '2', '3'];

export function companyToSupplierForm(company) {
  if (!company) {
    return {
      ticker: '',
      name: '',
      description: '',
      industry: '',
      tier: '1',
      sector: '',
      country: '',
      website: '',
      marketCap: '',
      employeeCount: '',
      keywords: [],
      supplyChainRisks: [],
      riskCategories: [],
    };
  }
  const resolvedTicker =
    company.ticker ||
    company.companyId ||
    company.company_id ||
    company.id ||
    '';

  return {
    ticker: String(resolvedTicker).trim(),
    name: company.name || '',
    description: company.description || '',
    industry: company.industry || '',
    tier: company.tier ? String(company.tier) : '1',
    sector: company.sector || '',
    country: company.country || '',
    website: company.website || '',
    marketCap: company.marketCap ? String(company.marketCap) : '',
    employeeCount: company.employeeCount ? String(company.employeeCount) : '',
    keywords: [...(company.keywords || [])],
    supplyChainRisks: [...(company.supplyChainRisks || [])],
    riskCategories: [...(company.riskCategories || [])],
  };
}

export function supplierFormToPayload(formData, fallbackTicker = '') {
  const ticker = String(formData.ticker || fallbackTicker || '').trim();

  const payload = {
    ticker,
    name: formData.name.trim(),
    description: formData.description.trim() || undefined,
    industry: formData.industry.trim(),
    tier: formData.tier,
    keywords: formData.keywords,
    supplyChainRisks: formData.supplyChainRisks,
    riskCategories: formData.riskCategories,
    sector: formData.sector.trim() || undefined,
    country: formData.country.trim() || undefined,
    website: formData.website.trim() || undefined,
    marketCap: formData.marketCap ? parseFloat(formData.marketCap) : undefined,
    employeeCount: formData.employeeCount ? parseInt(formData.employeeCount, 10) : undefined,
  };

  // Mirror camelCase fields for APIs that expect snake_case bodies.
  payload.supply_chain_risks = payload.supplyChainRisks;
  payload.risk_categories = payload.riskCategories;
  if (payload.marketCap != null) payload.market_cap = payload.marketCap;
  if (payload.employeeCount != null) payload.employee_count = payload.employeeCount;

  return payload;
}

/** PUT body for user-scoped update (includes ticker — required by API validation). */
export function supplierFormToUpdatePayload(formData, fallbackTicker = '') {
  return supplierFormToPayload(formData, fallbackTicker);
}
